module.exports = __webpack_public_path__ + "static/COUNSELLING-059d2ed8651785f499a1f861d419b502.png";